import React, { useContext, useState } from "react";

import { ErrorMessage } from "formik";
import InputTextareaComponent from "../../../form/components/InputTextAreaComponent";
import RadioButtonComponent from "../../../form/components/RadioButtonComponent";
import { FormContext } from "../../../form/context/formContext";

const ContextOfChildTable = ({ values, errors }: any) => {
  const context = useContext(FormContext);
  const [data] = useState([
    { text: "Complex Medical Needs", name: "complexMedicalNeeds", comments: "" },
    { text: "Physical", name: "physical", comments: "" },
    { text: "Specialised Equipment", name: "specialisedEquipment", comments: "" },
    { text: "Fine Motor", name: "fineMotor", comments: "" },
    { text: "Communication", name: "communication", comments: "" },
    { text: "Learning", name: "learning", comments: "" },
    { text: "Social", name: "social", comments: "" },
    { text: "Self-care Skills", name: "selfCareSkills", comments: "" },
    { text: "Behaviour", name: "behaviour", comments: "" },
  ]);

  return (
    <>
      <div className="contextChild p-datatable p-component p-datatable-responsive-scroll">
        <div className="py-2">
          <label className="isRequired">Select the level of additional support and guidance required by the child</label>
        </div>
        <div className="p-datatable-wrapper">
          <table className="p-datatable-table" role="table">
            <thead className="p-datatable-thead">
              <tr role="row">
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title"></span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">0</span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">1</span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">2</span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">3</span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">N/A</span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">Comments</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="p-datatable-tbody" role=" rowgroup">
              {data.map((rowData) => (
                <tr key={rowData.name} role="row">
                  <td>
                    {rowData.text}{" "}
                    {errors && (
                      <ErrorMessage
                        name={rowData.name}
                        render={(msg) => (
                          <div className="error">
                            <i aria-hidden="true" className="pi pi-info-circle mr-2"></i>
                            {msg}
                          </div>
                        )}
                      />
                    )}
                  </td>

                  <td>
                    <RadioButtonComponent
                      disabled={context.formContextStore.disabled}
                      name={rowData.name}
                      options={[{ label: "", value: 0 }]}
                      value={values[rowData.name]}
                      errorRequired={false}
                    />
                  </td>

                  <td>
                    <RadioButtonComponent
                      disabled={context.formContextStore.disabled}
                      name={rowData.name}
                      options={[{ label: "", value: 1 }]}
                      value={values[rowData.name]}
                      errorRequired={false}
                    />
                  </td>

                  <td>
                    <RadioButtonComponent
                      disabled={context.formContextStore.disabled}
                      name={rowData.name}
                      options={[{ label: "", value: 2 }]}
                      value={values[rowData.name]}
                      errorRequired={false}
                    />
                  </td>

                  <td>
                    <RadioButtonComponent
                      disabled={context.formContextStore.disabled}
                      name={rowData.name}
                      options={[{ label: "", value: 3 }]}
                      value={values[rowData.name]}
                      errorRequired={false}
                    />
                  </td>

                  <td>
                    <RadioButtonComponent
                      disabled={context.formContextStore.disabled}
                      name={rowData.name}
                      options={[{ label: "", value: 4 }]}
                      value={values[rowData.name]}
                      errorRequired={false}
                    />
                  </td>

                  <td>
                    <InputTextareaComponent
                      value={values[rowData.name + "Comment"]}
                      name={rowData.name + "Comment"}
                      disabled={context.formContextStore.disabled}
                      label={""}
                      warn={""}
                      className="scrollable-text"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ContextOfChildTable;
